<img
  [hidden]="invalidImage"
  title="{{ title }}"
  (load)="logoLoader()"
  (error)="logoLoadError()"
  src="{{ logoUrl }}"
  alt="{{ alt }}"
  [id]="componentId"
/>
<img
  [hidden]="!invalidImage || !errorUrl"
  title="{{ title }}"
  src="{{ errorUrl }}"
  alt=""
  [id]="componentId"
/>
<i
  [hidden]="!invalidImage || !errorIcon"
  title="{{ title }}"
  class="{{ errorIcon }}"
  [id]="componentId"
></i>
